var link_viewer_default = {
  "fontElementMap": "MTL96",
  "link": "l4I58",
  "linkInEditor": "hHYuK",
  "linkInViewer": "_9GQWw",
  "toolbarUrlContainer": "UjBPP",
  "toolbarUrl": "-Q9Sr",
  "toolbarUrlAnchor": "-lFaN"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
